import React from 'react';
import PostForm from './PostForm';
import VentCard from './VentCard';
import { TrendingUp, Users, Shield, Loader } from 'lucide-react';

const MainFeed = ({ posts, addPost, updateReaction, currentView, loading, hasMore, onLoadMore }) => {
  const renderContent = () => {
    switch (currentView) {
      case 'home':
        return (
          <>
            <PostForm onSubmit={addPost} />
            <div className="space-y-6">
              {posts.map(post => (
                <VentCard
                  key={post.id}
                  post={post}
                  onReaction={updateReaction}
                />
              ))}
              {loading && (
                <div className="flex justify-center py-8">
                  <Loader className="w-6 h-6 text-terminal-green animate-spin" />
                </div>
              )}
              {!loading && hasMore && posts.length > 0 && (
                <button
                  onClick={onLoadMore}
                  className="w-full py-3 text-terminal-green hover:bg-slate-800 rounded-lg"
                >
                  加载更多
                </button>
              )}
              {!loading && posts.length === 0 && (
                <div className="text-center py-12 text-slate-500">
                  暂无吐槽，来发第一条吧！
                </div>
              )}
            </div>
          </>
        );

      case 'ranking':
        return (
          <div className="space-y-6">
            <div className="bg-slate-800 border border-slate-700 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <TrendingUp className="w-6 h-6 text-warning-orange" />
                <h2 className="text-xl font-bold text-warning-orange">本周槽王排行榜</h2>
              </div>
              <p className="text-slate-400 mb-6">
                根据"恶心爆了"票数排名，看看哪些职场奇葩最让人无语
              </p>
            </div>

            <div className="space-y-4">
              {posts
                .sort((a, b) => b.reactions.disgusted - a.reactions.disgusted)
                .map((post, index) => (
                  <div key={post.id} className="flex items-start gap-4 bg-slate-800 border border-slate-700 rounded-xl p-6">
                    <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center font-bold ${index === 0 ? 'bg-yellow-500 text-slate-900' :
                        index === 1 ? 'bg-gray-400 text-slate-900' :
                          index === 2 ? 'bg-orange-600 text-white' :
                            'bg-slate-600 text-slate-300'
                      }`}>
                      {index + 1}
                    </div>
                    <div className="flex-1">
                      <p className="text-slate-200 mb-2">{post.content}</p>
                      <div className="flex items-center gap-4 text-sm text-slate-400">
                        <span>恶心爆了: {post.reactions.disgusted}</span>
                        <span>拥抱同行人: {post.reactions.support}</span>
                        <span>{post.timestamp}</span>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        );

      case 'my-posts':
        return (
          <div className="space-y-6">
            <div className="bg-slate-800 border border-slate-700 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <Users className="w-6 h-6 text-terminal-green" />
                <h2 className="text-xl font-bold text-terminal-green">我的吐槽记录</h2>
              </div>
              <p className="text-slate-400">
                由于匿名保护机制，我们无法追踪具体的发布记录。这是为了保护你的隐私安全。
              </p>
            </div>
          </div>
        );

      case 'anonymous':
        return (
          <div className="space-y-6">
            <div className="bg-slate-800 border border-slate-700 rounded-xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <Shield className="w-6 h-6 text-terminal-green" />
                <h2 className="text-xl font-bold text-terminal-green">匿名保护说明</h2>
              </div>

              <div className="space-y-4 text-slate-300">
                <div className="bg-slate-900 p-4 rounded-lg">
                  <h3 className="font-semibold text-terminal-green mb-2">🔒 隐私保护承诺</h3>
                  <ul className="space-y-2 text-sm">
                    <li>• 本站不记录用户IP地址</li>
                    <li>• 不要求实名注册</li>
                    <li>• 邮箱仅用于找回密码（可选）</li>
                    <li>• 所有吐槽内容完全匿名</li>
                  </ul>
                </div>

                <div className="bg-slate-900 p-4 rounded-lg">
                  <h3 className="font-semibold text-warning-orange mb-2">⚠️ 使用建议</h3>
                  <ul className="space-y-2 text-sm">
                    <li>• 避免在内容中透露具体公司名称</li>
                    <li>• 不要包含可能暴露身份的详细信息</li>
                    <li>• 理性吐槽，避免人身攻击</li>
                    <li>• 如有法律纠纷，建议寻求专业帮助</li>
                  </ul>
                </div>

                <div className="bg-slate-900 p-4 rounded-lg">
                  <h3 className="font-semibold text-blue-400 mb-2">💡 温馨提示</h3>
                  <p className="text-sm">
                    这里是你的情绪出口，但记住：吐槽只是第一步，
                    真正的改变需要你在现实中采取行动。加油，打工人！
                  </p>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="p-6 pt-24"> {/* pt-24 to account for danmaku overlay */}
      {renderContent()}
    </div>
  );
};

export default MainFeed;